import React from 'react';

import { Box } from '@betterment/samba-react';

function RowLeadingContent({ children }: React.PropsWithChildren) {
  return <Box css={{ display: 'grid' }}>{children}</Box>;
}

function RowTrailingContent({ children }: React.PropsWithChildren) {
  return <Box css={{ display: 'grid', alignItems: 'center' }}>{children}</Box>;
}

function ModalSectionRow({ children }: React.PropsWithChildren) {
  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        borderBottom: '1px solid',
        borderColor: 'border.weak',
        paddingBottom: 'space.200',
        _lastOfType: {
          borderBottom: 'none',
          paddingBottom: 'space.0',
        },
      }}
    >
      {children}
    </Box>
  );
}

ModalSectionRow.LeadingContent = RowLeadingContent;
ModalSectionRow.TrailingContent = RowTrailingContent;
ModalSectionRow.displayName = 'ModalSectionRow';

export { ModalSectionRow };
